// Vendor JS
import Debug from 'debug';

/**
 * To be fired on the search page
 */
export default {
	init: () => {
		try {
			Debug(`cig:info:sage:route:search`)(`init start`);

			// Search Filters
			// Will check and uncheck all publication checkboxes for filtering searches
			const searchFilterPubsToggle = document.querySelector('.search-filter-pubs-toggle');

			const checkedToggle = (event) => {
				const mediaInputs = document.querySelectorAll("input[name='smedia[]']");
				const isChecked = searchFilterPubsToggle.classList.contains('uncheck');

				if (isChecked) {
					searchFilterPubsToggle.innerHTML = '(check all)';
					searchFilterPubsToggle.classList.remove('uncheck');

				} else {
					searchFilterPubsToggle.innerHTML = '(uncheck all)';
					searchFilterPubsToggle.classList.add('uncheck');
				}

				for (const mediaInput of mediaInputs) {
					mediaInput.checked = (!isChecked);
				}

				return false;
			};

			if (searchFilterPubsToggle) {
				searchFilterPubsToggle.addEventListener('click', checkedToggle);
			}

		} catch (err) {
			Debug(`cig:error:sage:route:about`)(`Search Route init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},

	// Fires after init
	finalize: () => {
		try {
			Debug(`cig:info:sage:route:search`)(`finalize start`);

		} catch (err) {
			Debug(`cig:error:sage:route:search`)(`Search Route finalize Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}
};
